module.exports = __webpack_public_path__ + "static/img/beeftrend.50751b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/beeftrend.png
// module id = oeLR
// module chunks = 51